import React from "react";
import "./ReviewsSection.css";

// ✅ Görselleri assets klasöründen içe aktar
import child5 from "../assets/child_crop_5.png";
import child6 from "../assets/child_crop_6.png";
import child7 from "../assets/child_crop_7.png";

const reviews = [
  {
    name: "Ilgın A.",
    text: "Ottomun benim için unutulmaz bir deneyimdi! Harika organizasyon.",
    rating: 5,
    image: child5,
  },
  {
    name: "Adam R.",
    text: "Incredible team and a professional MUN experience!",
    rating: 4,
    image: child7,
  },
  {
    name: "Elif T.",
    text: "Katıldığım en iyi MUN konferansıydı, teşekkürler Ottomun!",
    rating: 5,
    image: child6,
  },
];

const ReviewsSection = () => {
  return (
    <section className="reviews-section">
      <h2>What Our Participants Say</h2>
      <div className="reviews-container">
        {reviews.map((r, index) => (
          <div className="review-card" key={index}>
            <img src={r.image} alt={r.name} className="review-img" />
            <h3>{r.name}</h3>
            <div className="stars">
              {"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}
            </div>
            <p>"{r.text}"</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ReviewsSection;
